<template>
    <DefaultLayout :title="title">

        <template #title>
            {{ __('admin::nav.group_tools') }}
            <ChevronRightIcon class="w-6 h-6 inline align-text-top text-gray-300" />
            {{ title }}
        </template>

        <template #default>

            <Panel>

                <form @submit.prevent="submit">

                    <slot></slot>

                    <Button :loading="form.processing">
                        {{ buttonText }}
                    </Button>

                </form>

            </Panel>

        </template>

    </DefaultLayout>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/outline'

export default {
    components: {
        ChevronRightIcon,
    },
    props: {
        route: String,
        title: String,
        buttonText: String,
        form: Object,
    },
    methods: {
        submit() {
            this.form.post(this.route);
        }
    },
}
</script>
